module.exports = __webpack_public_path__ + "img/asw.8cf3a550.png";